import { render, staticRenderFns } from "./File.vue?vue&type=template&id=43d06e8a&scoped=true&"
import script from "./File.vue?vue&type=script&lang=js&"
export * from "./File.vue?vue&type=script&lang=js&"
import style0 from "./File.vue?vue&type=style&index=0&id=43d06e8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d06e8a",
  null
  
)

export default component.exports